import type { KeyboardEvent, ReactNode } from "react";
import clsx from "clsx";

export interface ClickableTableRowProps {
  onActivate: () => void;
  children: ReactNode;
  className?: string;
  ariaLabel?: string;
}

export function ClickableTableRow({
  onActivate,
  children,
  className,
  ariaLabel,
}: ClickableTableRowProps) {
  function onKeyDown(e: KeyboardEvent<HTMLTableRowElement>) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onActivate();
    }
  }

  return (
    <tr
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      className={clsx("eh-table-row--clickable cursor-pointer", className)}
      onClick={onActivate}
      onKeyDown={onKeyDown}
    >
      {children}
    </tr>
  );
}
